import { Drawer, Button, Space, Typography, Grid } from 'antd';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';

const { useBreakpoint } = Grid;

const { Link, Text } = Typography;

export function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const navLinks = [
    { label: 'Features', href: '#features' },
    { label: 'Pricing', href: '#pricing' },
    { label: 'API Docs', href: '#docs' },
    { label: 'Security', href: '#security' },
  ];

  return (
    <nav
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        backdropFilter: 'blur(12px)',
        zIndex: 1000,
        borderBottom: '1px solid #f0f0f0',
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          padding: '16px 24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {/* Logo */}
        <Space align="center" size="small">
          <img src="/logo-icon.png" alt="iSubscribe" width="28" height="28" />
          <Text strong style={{ fontSize: '20px', color: '#7c3aed' }}>
            iSubscribe
          </Text>
        </Space>

        {/* Desktop Links */}
        <div
          style={{ display: isMobile ? 'none' : 'flex', alignItems: 'center' }}
        >
          <Space size={32}>
            {navLinks.map((link) => (
              <Link
                key={link.label}
                href={link.href}
                style={{
                  color: '#595959',
                  fontWeight: 500,
                  fontSize: '14px',
                }}
              >
                {link.label}
              </Link>
            ))}
            <Button type="primary" size="large" href="/login">
              Start Free Trial
            </Button>
          </Space>
        </div>

        {/* Mobile Toggle */}
        <Button
          type="text"
          style={{ display: isMobile ? 'inline-flex' : 'none' }}
          icon={mobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        />

        {/* Mobile Menu Drawer */}
        <Drawer
          title="Menu"
          placement="right"
          onClose={() => setMobileMenuOpen(false)}
          open={mobileMenuOpen}
          styles={{ body: { padding: '24px 16px' } }}
        >
          <Space orientation="vertical" size="large" style={{ width: '100%' }}>
            {navLinks.map((link) => (
              <Link
                key={link.label}
                href={link.href}
                onClick={() => setMobileMenuOpen(false)}
                style={{
                  color: '#262626',
                  fontWeight: 500,
                  fontSize: '16px',
                  display: 'block',
                }}
              >
                {link.label}
              </Link>
            ))}
            <Button
              type="primary"
              size="large"
              block
              href="/login"
              onClick={() => setMobileMenuOpen(false)}
            >
              Start Free Trial
            </Button>
          </Space>
        </Drawer>
      </div>
    </nav>
  );
}
